<template>
<el-dialog title="选择人员" width="80%" :visible.sync="viewData.visible" :close-on-click-modal="false" append-to-body>
    <div class="user-settings">
        <el-form :inline="true" size="mini" :model="dataForm" @keyup.enter.native="getDataList()">
            <el-form-item label="用户名">
                <el-input size="mini" v-model="dataForm.loginName" placeholder="用户名" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="姓名">
                <el-input size="mini" v-model="dataForm.realName" placeholder="姓名" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <!-- <el-form-item label="邮箱">
                <el-input size="mini" v-model="dataForm.mail" placeholder="邮箱" clearable @blur="getDataList"></el-input>
            </el-form-item> -->
            <el-form-item class="fr">
                <el-button icon="el-icon-search" size="mini" class="cla-user-search" @click="getDataList()">查询
                </el-button>
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :data="dataList" size="mini" @current-change="currentChange" :header-cell-style="{background:'#f5f5f5'}" highlight-current-row style="width: 100%;" border @selection-change="selectionChangeHandle">
                <el-table-column type="index" header-align="left" align="left" width="50" label="序号">
                </el-table-column>
                <el-table-column prop="loginName" header-align="center" align="left" min-width="100" label="用户名">
                </el-table-column>
                <el-table-column prop="realName" header-align="center" align="left" width="100" label="姓名">
                    <template slot-scope="scope">
                        <span>{{scope.row.realName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="roleList" header-align="center" align="center" width="120" label="角色">
                    <template slot-scope="scope">
                        <span :key="item.id" v-for="item in scope.row.roleList" size="small" type="info">{{item.roleName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="positionName" header-align="center" align="center" width="120" label="岗位">
                    <template slot-scope="scope">
                        <span :key="item.id" v-for="item in scope.row.positionList" size="small" type="info">{{item.positionName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="orgList" header-align="center" align="left" min-width="150" label="组织">
                    <template slot-scope="scope">
                        <span :key="item.id" v-for="item in scope.row.orgList">
                            {{item.orgName}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="mainBodyList" header-align="center" align="left" width="250" label="主体">
                    <template slot-scope="scope">
                        <span :key="item.id" v-for="item in scope.row.mainBodyList">
                            {{item.mainBodyName}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="mail" header-align="center" align="right" width="200" label="邮箱">
                </el-table-column>
                <el-table-column prop="mobile" header-align="center" align="right" width="120" label="手机号">
                </el-table-column>
            </el-table>
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper" style="text-align:right" class="mt15 mb15">
            </el-pagination>
        </div>
    </div>
    <el-row :gutter="40">
        <el-col :span="24" style="text-align:right;">
            <el-button size="small" @click="viewData.visible = false">
                取消
            </el-button>
            <!-- 询价中 -->
            <el-button size="small" type="primary" @click="confirm()">
                确认
            </el-button>
        </el-col>
    </el-row>
</el-dialog>
</template>

<script>
import {
    fetchUserList,
    updatePassword,
    deleteUser
} from '@/controller/sys'
import {
    DIALOG_CLOSED_TYPE,
    USER_TYPE
} from '@/utils/const'
export default {
    data() {
        return {
            viewData: {
                visible: false,
                width: ''
            },
            userList: [{
                id: 1,
                realName: '超级管理员'
            }, {
                id: 2,
                realName: '超级管理员1'
            }],
            currentRow: {
                id: 1,
                realName: '超级管理员'
            },
            userId: 0,
            typeId: 0,
            dialogFormVisible: false,
            dataForm: {
                loginName: '',
                realName: '',
                newPassword: '',
                confirmPassword: ''
            },
            dataList: [],
            userTypeList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            USER_TYPE: USER_TYPE,
            dataListLoading: false,
            dataListSelections: [],
            assignRoleInfoVisible: false,
            addOrUpdateVisible: false,
            assignPositionInfoVisible: false,
            assignOrgInfoVisible: false,
            drawerInfoVisible: false
        }
    },
    mounted() {},
    activated() {
        this.getDataList()
    },
    methods: {
        open(typeId) {
            this.typeId = typeId
            console.log(typeId)
            this.viewData.visible = true
            this.pageSize = 10
            this.pageIndex = 1
            this.getDataList()
        },
        onClosed(params) {
            console.log(params)
            return;
        },
        // 筛选按钮弹框取消
        cancel() {
            this.close();
        },
        close(option = DIALOG_CLOSED_TYPE.CLOSE) {
            if (!this.viewData.visible) {
                return;
            }
            if (this.multiple) {
                this.onClosed({
                    option,
                    sender: this,
                    data: this.userList,
                });
            } else {
                this.onClosed({
                    option,
                    sender: this,
                    data: this.currentRow,
                });
                console.log(this.currentRow)
            }
            this.viewData.visible = false;
        },
        confirm() {
            this.close(DIALOG_CLOSED_TYPE.CONFIRM);
        },

        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            fetchUserList({
                'pageNo': this.pageIndex,
                'pageSize': this.pageSize,
                'loginName': this.dataForm.loginName,
                'realName': this.dataForm.realName,
                'typeId': this.typeId
            }).then(data => {
                if (data && data.code === '00') {
                    this.dataList = data.body.records
                    this.totalPage = data.body.total
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        currentChange(currentRow) {
            console.log(currentRow);
            this.currentRow = currentRow;
        },
        // 新增
        addOrUpdateHandle(id) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id)
            })
        },
        showDrawerHandle(id) {
            this.drawerInfoVisible = true
            this.$nextTick(() => {
                this.$refs.drawerInfo.init(id)
            })
        },
        sortChangeHandle(sort) {
            //TODO 传参
            console.log(sort.prop)
            console.log(sort.order)
        },
        assignRoleHandle() {
            if (this.dataListSelections.length > 1) {
                this.$message.info('只能选择一条记录')
                return
            }
            let id = this.dataListSelections[0].id
            let ids = this.dataListSelections[0].roleList.map(item => {
                return item.roleId
            })
            this.assignRoleInfoVisible = true
            this.$nextTick(() => {
                this.$refs.assignRoleInfo.init(id, ids)
            })
        },
        assignPositionHandle() {
            if (this.dataListSelections.length > 1) {
                this.$message.info('只能选择一条记录')
                return
            }
            let id = this.dataListSelections[0].id
            let ids = this.dataListSelections[0].positionList.map(item => {
                return item.positionId
            })
            this.assignPositionInfoVisible = true
            this.$nextTick(() => {
                this.$refs.assignPositionInfo.init(id, ids)
            })
        },
        assignOrgHandle() {
            if (this.dataListSelections.length > 1) {
                this.$message.info('只能选择一条记录')
                return
            }
            let id = this.dataListSelections[0].id
            let ids = this.dataListSelections[0].orgList.map(item => {
                return item.orgId
            })
            this.assignOrgInfoVisible = true
            this.$nextTick(() => {
                this.$refs.assignOrgInfo.init(id, ids)
            })
        },

        initPasswordHandle(id) {
            this.userId = id
            this.dialogFormVisible = true
        },
        dataFormSubmit() {
            this.$refs['temp'].validate((valid) => {
                if (valid) {
                    updatePassword({
                        'id': this.userId,
                        'password': this.temp.newPassword
                    }).then(data => {
                        if (data && data.code === '00') {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.getDataList()
                                }
                            })
                        } else {
                            this.$message.error(data.msg)
                        }
                        this.dialogFormVisible = false
                    })
                }
            })
        },
        // 删除
        deleteHandle(id) {
            let ids = id ? [id] : this.dataListSelections.map(item => {
                return item.id
            })
            this.$confirm(`确定进行${id ? '删除' : '批量删除'}操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteUser(ids).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {})
        }
    }
}
</script>

<style lang="scss">
.el-dialog__body {
    .org-dialog-form {
        width: 95%;
    }
}

.linetext {
    white-space: pre-line;
}

.el-table__body {
    tr.current-row>td {
        color: #fff;
        background-color: #409EFF !important;
    }
}

.fr {
    float: right;
}

.mt15 {
    margin-top: 15px;
}

.mb {
    margin-bottom: 15px;
}
</style>
